// A full page load that replaces the current history entry, so Back skips the
// page that redirected. Use it instead of `router.replace` when the target page
// has to be requested from the server, such as a page that sets cookies.
export function fullPageReplace(url: string) {
  window.location.replace(url);
}
